import { render, staticRenderFns } from "./ConflictingBeaconToClusterConfirmation.vue?vue&type=template&id=1db6b4fb&"
import script from "./ConflictingBeaconToClusterConfirmation.vue?vue&type=script&lang=js&"
export * from "./ConflictingBeaconToClusterConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports